export type ExperimentProvenance = { flag: string; variant: string }

/**
 * Read the experiment flag + rendered variant from the nearest
 * `data-experiment` ancestor (stamped by `<Experiment>` in edit builds), or
 * null when the clicked text isn't inside an A/B-gated arm. Lets the editor
 * warn which arm is being changed instead of silently editing the wrong one.
 */
export function resolveExperiment(
  el: HTMLElement
): ExperimentProvenance | null {
  const host = el.closest<HTMLElement>("[data-experiment]")
  if (!host) return null
  const flag = host.dataset.experiment
  if (!flag) return null
  return { flag, variant: host.dataset.variant ?? "control" }
}
